export const getPageCount = (count: number, pageSize: number) => {
  const numberOfPages = Math.ceil(count / pageSize)
  return numberOfPages
}
